import { Sector } from '@/domain/impact/impact.entity';
import { CalculateFestivalCo2 } from '@/domain/impact-calculate-festival/entities/calculate-festival-co2.entity';
import { References } from '@/domain/impact-references/entities/references.entity';
import { translate } from '@/ui/i18n';
import { TopicScoreDetailsData } from '@/ui/pages/app/components/topic-score-card/type';

export function prepareScoreSectorDetailsDataCo2(
  calculateCo2: CalculateFestivalCo2,
  references: References,
  sector: Sector | null,
): TopicScoreDetailsData {
  switch (sector) {
    case 'TEAM':
      return buildTeam(calculateCo2, references);
    case 'ARTISTS':
      return buildArtist(calculateCo2, references);
    case 'PUBLIC':
      return buildPublic(calculateCo2, references);
    case 'SITE':
      return buildSite(calculateCo2, references);
    case '':
    case 'ANY':
    case null:
      throw 'sector should be set';
  }
}

function buildTeam(
  calculateCo2: CalculateFestivalCo2,
  references: References,
): TopicScoreDetailsData {
  return {
    value: calculateCo2.sectors.team.score,
    refValue: references.sectors.team.co2.score,
    maxValue: NaN,
    completion: calculateCo2.sectors.team.completion,
    sections: [
      {
        name: translate('Projects.details'),
        items: [
          {
            id: 'mobility',
            name: translate('Co2.Sections.MOBILITY'),
            value: calculateCo2.sectors.team.categories.mobility.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'catering',
            name: translate('Co2.Sections.CATERING'),
            value: calculateCo2.sectors.team.categories.catering.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'accommodation',
            name: translate('Co2.Sections.ACCOMMODATION'),
            value: calculateCo2.sectors.team.categories.accommodation.score,
            unit: translate('Projects.teCO2'),
          },
        ],
      },
    ],
  };
}

function buildArtist(
  calculateCo2: CalculateFestivalCo2,
  references: References,
): TopicScoreDetailsData {
  return {
    value: calculateCo2.sectors.artists.score,
    refValue: references.sectors.artists.co2.score,
    maxValue: NaN,
    completion: calculateCo2.sectors.artists.completion,
    sections: [
      {
        name: translate('Projects.details'),
        items: [
          {
            id: 'mobility',
            name: translate('Co2.Sections.MOBILITY'),
            value: calculateCo2.sectors.artists.categories.mobility.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'catering',
            name: translate('Co2.Sections.CATERING'),
            value: calculateCo2.sectors.artists.categories.catering.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'accommodation',
            name: translate('Co2.Sections.ACCOMMODATION'),
            value: calculateCo2.sectors.artists.categories.accommodation.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'cargo',
            name: translate('Co2.Sections.CARGO'),
            value: calculateCo2.sectors.artists.categories.cargo.score,
            unit: translate('Projects.teCO2'),
          },
        ],
      },
    ],
  };
}
function buildPublic(
  calculateCo2: CalculateFestivalCo2,
  references: References,
): TopicScoreDetailsData {
  return {
    value: calculateCo2.sectors.public.score,
    refValue: references.sectors.public.co2.score,
    maxValue: NaN,
    completion: calculateCo2.sectors.public.completion,
    sections: [
      {
        name: translate('Projects.details'),
        items: [
          {
            id: 'mobility',
            name: translate('Co2.Sections.MOBILITY'),
            value: calculateCo2.sectors.public.categories.mobility.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'catering',
            name: translate('Co2.Sections.CATERING'),
            value: calculateCo2.sectors.public.categories.catering.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'accommodation',
            name: translate('Co2.Sections.ACCOMMODATION'),
            value: calculateCo2.sectors.public.categories.accommodation.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'digital',
            name: translate('Co2.Sections.DIGITAL'),
            value: calculateCo2.sectors.public.categories.digital.score,
            unit: translate('Projects.teCO2'),
          },
        ],
      },
    ],
  };
}

function buildSite(
  calculateCo2: CalculateFestivalCo2,
  references: References,
): TopicScoreDetailsData {
  return {
    value: calculateCo2.sectors.site.score,
    refValue: references.sectors.site.co2.score,
    maxValue: NaN,
    completion: calculateCo2.sectors.site.completion,
    sections: [
      {
        name: translate('Projects.details'),
        items: [
          {
            id: 'energy',
            name: translate('Co2.Sections.ENERGY'),
            value: calculateCo2.sectors.site.categories.energy.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'equipment',
            name: translate('Co2.Sections.EQUIPMENT'),
            value: calculateCo2.sectors.site.categories.equipment.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'water',
            name: translate('Co2.Sections.WATER'),
            value: calculateCo2.sectors.site.categories.water.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'waste',
            name: translate('Co2.Sections.WASTE'),
            value: calculateCo2.sectors.site.categories.waste.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'cargo',
            name: translate('Co2.Sections.CARGO'),
            value: calculateCo2.sectors.site.categories.cargo.score,
            unit: translate('Projects.teCO2'),
          },
          {
            id: 'building',
            name: translate('Co2.Sections.BUILDING'),
            value: calculateCo2.sectors.site.categories.building.score,
            unit: translate('Projects.teCO2'),
          },
        ],
      },
    ],
  };
}
